import {uploadFileWithServe} from "@/api/file-api";


export const uploadFile = (file, path) => {
    return uploadFileWithSelfServe(file, path)
}

export const getFileUrl = (path) => {
    return getFileUrlWithSelfServe(path)
}


function uploadFileWithSelfServe(file, objectKey) {
    console.log("uploadFileWithSelfServe", file, objectKey)
    return uploadFileWithServe(file.raw, objectKey)
}

function getFileUrlWithSelfServe(objectKey) {
    if (!objectKey) {
        return ""
    }
    if (objectKey.startsWith("http")) {
        return objectKey
    }
    return "/api/file/download/" + objectKey
}
